module.exports = __webpack_public_path__ + "static/media/S4N8-5.2c3dde71.svg";